// src/components/Loader.jsx
export default function Loader() {
  return (
    <div className="h-screen flex items-center justify-center bg-gray-50">
      <div className="flex space-x-2">
        <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce"></div>
        <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce delay-150"></div>
        <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce delay-300"></div>
      </div>
    </div>
  );
}
